import { render, staticRenderFns } from "./battery.vue?vue&type=template&id=19d6c642&scoped=true"
import script from "./battery.vue?vue&type=script&lang=js"
export * from "./battery.vue?vue&type=script&lang=js"
import style0 from "./battery.vue?vue&type=style&index=0&id=19d6c642&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_ubrbtih2qfyokjyfwkrqqblaa4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d6c642",
  null
  
)

export default component.exports